import { render } from "./app.vue?vue&type=template&id=175080bc"
import script from "./app.ts?vue&type=script&lang=js"
export * from "./app.ts?vue&type=script&lang=js"

import "./app.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script